import React, { useEffect, useState } from "react";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import Button from "../../components/shared/Button";
import { Link, useNavigate } from "react-router-dom";
import apiClient from "../../components/utils/apiClient";

const ForgetPasswordPage = () => {

  const {i18n,t} = useTranslation();
  useDocumentTitle('pageTitles.login');
  const navigate = useNavigate();
  const [isFormSubmitDisabled,setIsFormSubmitDisabled] = useState(true);
  const [signInForm,setSignInForm] = useState({email:''});
  const [errors, setErrors] = useState(null);
  const [emailSent, setEmailSent] = useState(false);


  const hideError = (err) => {
    if(errors) {
      let errorsList = errors;
      delete errorsList[err];
      setErrors(errorsList);
    }
  }

  useEffect(()=>{
    if(signInForm && signInForm?.email) {
      setIsFormSubmitDisabled(false);
    } else {
      setIsFormSubmitDisabled(true);
    }
  },[signInForm])

  const handleClickResetPasswordButton = async () => {
    setIsFormSubmitDisabled(true);
    try {
      const response = await apiClient.post(`/b-users/forgot-password`,Object.fromEntries(Object.entries(signInForm).filter(([_, v]) => v !== '')));
      if(response?.status === 200 || response?.status === 204 || response?.status === 201) {
        setEmailSent(true);        
      }
    } catch(err) {
      setIsFormSubmitDisabled(false);
      if(err?.response?.data?.message) {
        let errorsList = {};
        errorsList.password = err?.response?.data?.message;
        setErrors(errorsList)
      } else {
        let errorsList = {};
        errorsList.OTP =err?.response?.data?.message;
        setErrors(errorsList);
      }
    }
  }
 

  // console.log(isFormSubmitDisabled);
  return (
    emailSent
      ? <div className="w-full">
          <div className="w-full text-center">
              <div className="text-center">
                <img src="/assets/images/success.svg" alt="" className="inline-block w-[88px] h-[88px] mb-[8px]" />
              </div>
              <p className="text-[32px] text-grey-900 font-[500] mb-[8px]">لقد قمنا بارسال رابط التحقق علي ايميلك</p>
              <p className="text-[18px] text-grey-600 font-[500]">من فضلك قم بمراجعة صندوق الوارد في ايميلك لقد قمنا بارسال رابط تغيير كلمة المرور علي ايمييلك المسجل.</p>
          </div>
        </div>
      :<div className="w-full">
          <h3 className="text-grey-900 font-[600] text-[32px] leading-[48px]">هلا بك في فني أعمال</h3>
          <p className="text-grey-600 font-[500] text-[18px] leading-[27px] mt-[15px] mb-[40px]">هنا يمكنك التحكم في إدارة و صيانة عقاراتك بكل سهولة و فعالية</p>
          <p className="text-grey-900 font-[500] text-[18px] leading-[27px]">هل نسيت كلمة المرور؟</p>
          <div className="w-full max-w-[450px] pt-[40px]">
              <p className="text-grey-900 text-[18px] font-[500] mb-[30px]">من فضلك قم بادخال الايميل المسجل.</p>
              <div className="mb-[20px]">
                <InputField label={'البريد الإلكتروني'} value={signInForm?.email} error={errors?.email} errorMessage={errors?.email} translateError={true} onChange={(e)=>{ if(e.target.value === '' || e.target.value) { setSignInForm({ ...signInForm, email: e.target.value }) }; hideError('email')}} />
              </div>
              <div className="mb-[35px]">
                <Button type="button" text={`ارسال رابط التحقق`} disabled={isFormSubmitDisabled} onClick={handleClickResetPasswordButton} />
              </div>
            <p className="text-grey-600 text-[18px] font-[500] leading-[27px]">إذا كنت لا تمتلك حساب من فضلك قم  <Link className="text-blue font-[700]" to={process.env.REACT_APP_API_URL === 'https://beta-production-api.fanni.site' ? `https://business.fanni.sa/packages.html` : `https://staging-business.fanni.sa/packages.html`}>بإنشاء حساب جديد</Link>.</p>
          </div>
        </div>
  );
};

export default ForgetPasswordPage;
